module.exports = __webpack_public_path__ + "img/banner-desktop.f76ea3fa.jpg";